// client/src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./i18n";

// ✅ add this
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ register AFTER render, so the UI isn't blocked
serviceWorkerRegistration.register();